export default {
  en: {
    createOrg: 'Create organization',
  },

  ru: {
    createOrg: 'Создать организацию',
  },
}
